import { render } from "./ZoomControls.vue?vue&type=template&id=f629207c&scoped=true"
import script from "./ZoomControls.vue?vue&type=script&lang=js"
export * from "./ZoomControls.vue?vue&type=script&lang=js"

import "./ZoomControls.vue?vue&type=style&index=0&id=f629207c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f629207c"]])

export default __exports__